import { gql } from '@apollo/client';

export const GET_DEVICE_TYPES = gql`
  query GetPhoneDeviceTypes {
    deliveredFieldDefinition(code: PHONE_DEVICE_TYPE) {
      values {
        label
        code
        value
      }
    }
  }
`;
